import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import backgroundImage from "../../images/location_new/case-img.jpg";
import { Link } from "gatsby";

function CaseSection(props) {
  return (
    <div
      className="common_section p-100"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={6} xl={5} xxl={6} className="my-auto">
            <div className="example" data-text="">
              <h2>Built to Lead Mobile Applications</h2>
            </div>
            <p>
              The mobile app sector is booming, with a 6.87% CAGR, leading us to
              over $250.5 billion in projected revenue in 2029. Now that there
              is an app for everything (payments, food delivery, healthcare, and
              more), get your business a performant, niche-specific, interactive
              application that compels engagement, increases accessibility, and
              boosts visibility.
            </p>
            <p>
              Make it possible with skilled business analysts, product
              technologists, and mobile app developers in Austin under one roof
              – at TekRevol. Whether ready-to-use white labels or
              building-from-scratch custom platforms, our result-driven app
              development company in Austin provides the right solution for
              every possible use case.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Let’s Start with a Free Consultation
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default CaseSection;
